<template>
  <div class="home">
    <div class="banner">
      <img :src="banner1" alt="">
      <img :src="banner2" alt="">
      <img :src="banner3" v-if="!ifSignIn" alt="">
      <img :src="banner31" v-if="ifSignIn" alt="">

      <div class="check-merchant" @click="checkMerchant"></div>

      <div class="action-btn" v-if="!ifSignIn" @click="signIn"></div>

    </div>

    <div class="rule">
      <img :src="rule1" alt="">
    </div>

    <Popup v-model="modal.show">
      <div class="modal">
        <div class="modal-header">
          <img :src="header1" alt="">
        </div>
        <div class="modal-container-1">
          <div class="modal-container">
            <div class="header">{{ modal.title }}</div>
            <div class="content-prize" v-if="modal.prizeImg">
              <div class="prize-img">
                <img :src="modal.prizeImg" alt="">
              </div>
              <div class="prize-content">
                请务必点击下方按钮，跳转至 <br>
                “粤特权”微信小程序领取您的立减金。
              </div>
            </div>
            <div class="content" v-else v-html="modal.content"></div>
            <div class="action" @click="modalBtnClick">{{ modal.btnTxt }}</div>
          </div>
        </div>

        <div class="modal-close" @click="closeModal"></div>
      </div>
    </Popup>

    <!--登录-->
    <Popup v-model="loginBoxShow">
      <div class="modal">
        <div class="modal-header">
          <img :src="header1" alt="">
        </div>
        <div class="modal-container-1">
          <div class="modal-container" style="padding: 0 0 23px 0">
            <div class="header">{{ '用户验证' }}</div>
            <div class="login-content">
              <FzsLogin @onSuccessLogin="onSuccessLogin" :cipherText="cipherText"/>
            </div>
          </div>
        </div>
        <div class="modal-close" @click="toggleLoginShow"></div>
      </div>
    </Popup>

  </div>
</template>

<script>
// @ is an alias to /src
import _ from 'lodash'

import $windowConfig from '@/fzs-public/WindowConfig'
import ActivityTools from '@/fzs-public/fzs.utils/ActivityTools'
import { isBocApp } from '@/fzs-public/fzs.utils/env'
import '@/fzs-public/fzs.utils/BIAnalysis.js'
import localStorage from '@/fzs-public/webStorage/Storage.js'

import FzsLogin from '@/fzs-public/fzs.component/FzsLogin/FzsLogin'

import $httpActivity from '@/fzs-public/fzs.http/Activity.Http'
import $httpBoc from '@/fzs-public/fzs.http/Boc.Http'
import { Popup } from 'vant'

const banner1 = require('@/assets/1.jpg')
const banner2 = require('@/assets/2.jpg')
const banner3 = require('@/assets/3.jpg')
const banner31 = require('@/assets/3-1.jpg')
const rule1 = require('@/assets/4.png')
const header1 = require('@/assets/5.png')

class LocalDataBase {
  static get userInfo () {
    return localStorage.get('boc_userInfo')
  }

  static set userInfo (value) {
    localStorage.set('boc_userInfo', value)
  }

  static get ifSignIn () {
    return localStorage.get('boc_ifSignIn')
  }

  static set ifSignIn (value) {
    localStorage.set('boc_ifSignIn', value)
  }
}

export default {
  name: 'HomeView',

  components: {
    Popup,
    FzsLogin
  },

  data () {
    return {
      banner1,
      banner2,
      banner3,
      banner31,
      rule1: $windowConfig.ruleImgUrl || rule1,
      header1,

      ifSignIn: false,

      modal: {
        show: false,
        title: '温馨提示',
        content: '',
        prizeImg: '',
        btnTxt: '我知道了',
      },

      loginBoxShow: false,

      userInfo: {
      },




      taskList: [],

      cipherText: '',

      checked: false,

      isBocApp,
    }
  },

  methods: {
    init () {
      const userInfo = LocalDataBase.userInfo

      if (userInfo && userInfo.token) {
        this.userInfo = userInfo
        this.checkIfSign()
        this.queryTaskAll()
      } else {
        this.toggleLoginShow()
      }
    },

    // 检查是否已报名
    checkIfSign () {
      const ifSignIn = LocalDataBase.ifSignIn
      const { mobile } = this.userInfo

      this.ifSignIn = (ifSignIn && ifSignIn.includes('*' + mobile + '*'))
    },

    // 设置报名
    setIfSign () {
      const ifSignIn = LocalDataBase.ifSignIn
      const { mobile } = this.userInfo

      this.ifSignIn = true

      LocalDataBase.ifSignIn = ifSignIn + '*' + mobile + '*'
    },




    toggleLoginShow () {
      this.loginBoxShow = !this.loginBoxShow
    },

    showModal (obj = {}) {
      this.modal = {
        ...this.modal,
        show: true,
        ...obj
      }
    },

    closeModal () {
      this.modal.show = false
      window.setTimeout(() => {
        this.modal = {
          show: false,
          title: '温馨提示',
          content: '',
          prizeImg: '',
          btnTxt: '我知道了',
        }
      }, 500)
    },

    showOutTokenModal () {
      this.showModal({
        content: '登录已过期啦，请您重新登录～',
        btnTxt: '重新登录'
      })
      this.userInfo = {}
      LocalDataBase.userInfo = {}
    },

    modalBtnClick () {
      if (this.modal.btnTxt.includes('登录')) {
        this.toggleLoginShow()
        this.closeModal()
      } else {
        this.closeModal()
      }
    },



    checkMerchant () {
      window.location.href = $windowConfig.merchantJumpUrl
    },




    // http
    queryTaskAll (callback = () => {
    }) {
      const {
        token: authToken,
        userId
      } = this.userInfo
      $httpActivity.queryCheckWhiteTaskAll({
        authToken,
        userId,
      }).then(resp => {
        if (resp.success) {
          this.taskList = _.get(resp, ['datas', 'taskList'], [])

          callback && callback()
        } else {
          const {
            errorCode = '',
            errorMsg = '哎呀，活动太火爆了，请稍后再来~'
          } = resp
          if (errorCode === '410015') {
            this.showOutTokenModal()
          } else if (errorCode === '400038') {
            this.showModal({
              content: `活动已结束啦！<br>
              移步去看看别的活动吧~`,
              btnTxt: '我知道了'
            })
          } else if (errorCode === '400037' || errorMsg.includes('未开始')) {
            this.showModal({
              content: '活动暂未开始哦！',
              btnTxt: '我知道了'
            })
          } else {
            const msg = ActivityTools.querySchemeErrorMsg(errorCode) || errorMsg
            this.showModal({
              content: msg
            })
          }
        }
      })
    },

    // http
    signIn () {
      if (!this.userInfo.token) {
        return this.init()
      }

      this.queryTaskAll(() => {
        this.signIn1()
      })
    },

    // http
    signIn1 () {
      const {
        token,
        userId,
        mobile,
      } = this.userInfo

      if (!token || !userId || !mobile) return this.showOutTokenModal()

      const task = this.taskList.find(o => ('' + o.taskId) === $windowConfig.taskId)

      if (!task) return this.showModal({ content: '该任务配置不存在' })

      const result = ActivityTools.taskResolver(task)

      if (!result.success) {
        if (result.code === ActivityTools.taskResolverCodes.noWhite) {
          this.showModal({ content: '您暂未满足该报名条件<br>不能报名哦' })
        } else if (result.code.includes('grabOver')) {
          this.showModal({ content: '哎呀，手慢了，报名名额已<br>' + '被抢完，请稍后再来~' })
        } else if (result.code.includes('hadJ')) {
          this.showModal({
            content: '您已报过名啦，请勿重复报名~'
          })
          this.setIfSign()
        } else {
          this.showModal({ content: '您暂未满足该报名条件<br>不能报名哦' })
        }
      } else {
        const action = _.get(task, ['actionList', 0], {})
        const { actionNo } = action

        $httpBoc.recordBocMobileOpenId({ ...this.userInfo, actionNo }).then(resp => {
          const { success, errorCode, errorMsg } = resp

          if (success) {
            this.showModal({
              content: '<div style="text-align: justify">' + $windowConfig.successTip + '</div>'
            })
            this.setIfSign()
          } else {
            if (errorCode === '440045' || errorCode === '440046') {
              this.showModal({
                content: '您已报过名啦，请勿重复报名~'
              })
              this.setIfSign()

            } else {
              this.showModal({
                content: errorMsg || '哎呀，报名失败了，请稍后重试~'
              })
            }
          }
        })

      }



    },

    onSuccessLogin (userInfo) {
      this.loginBoxShow = false
      this.userInfo = userInfo

      LocalDataBase.userInfo = userInfo

      this.checkIfSign()
      this.queryTaskAll()
    }
  },

  mounted () {
    window.index = this

    this.init()
  }
}
</script>

<style lang="scss">
$cl-red: #ba0005;

.home {
  height: 100%;
  overflow-y: auto;
  overflow-x: hidden;
  background-color: $cl-red;
  background: linear-gradient(90deg, #ba0005 0%, #b60106 100%);

  .banner {
    line-height: 0;
    position: relative;

    > img {
      width: 100%;
    }

    .check-merchant {
      position: absolute;
      width: 260px;
      height: 72px;
      background-color: transparent;
      z-index: 9;
      top: 35px;
      right: 12px;
    }

    .action-btn {
      width: 720px;
      height: 165px;
      background-color: transparent;
      position: absolute;
      bottom: 138px;
      margin-left: 50%;
      transform: translate(-50%, 0);
    }


    .banner-1 {
      img {
        width: 100%;
      }
    }

    .banner-desc {
      padding: 10px 0 20px 0;
      display: flex;
      justify-content: center;
      align-items: center;

      .icon {
        width: 38px;
        height: 38px;
        display: inline;
        align-self: center;
        position: relative;

        img {
          width: 100%;
        }

        .checked {
          position: absolute;
          top: 1px;
          left: 0;
        }

        //width: 38px*2;
        //height: 38px*2;
        //background-size: 100% 100%;
        //background-image: url(../assets/check.png);
      }

      .desc {
        padding: 0 0 0 8px;
        color: #fff;
        font-size: 33px;
      }
    }

    .fun-rule {
      width: 117px;
      height: 99px;
      background-image: url(../assets/rule.png);
      background-size: 100% 100%;
      position: absolute;
      top: 33px;
      right: 16px;
    }

    .fun-my-prize {
      width: 117px;
      height: 103px;
      background-image: url(../assets/my-prize.png);
      background-size: 100% 100%;
      position: absolute;
      top: 148px;
      right: 16px;
    }

    .fun-poster {
      width: 117px;
      height: 106px;
      background-image: url(../assets/poster.png);
      background-size: 100% 100%;
      position: absolute;
      top: 399px;
      right: 16px;
    }
  }

  .desc-1 {
    font-size: 39px;
    color: #fff;
    opacity: .7;
    position: relative;
    margin-top: -20px;
    margin-bottom: 30px;
  }

  .rule {
    margin-top: -30px;
    position: relative;
    z-index: 9;
    > img {
      width: 100%;
    }
  }

  .fzs-login-box .flb-form {
    padding: 0;
    .flb-row-protocol {
      background-color: transparent;
    }
  }

  .task {
    .task-img {
      width: 980px;
      height: 294px;
      margin: -10px auto 0 auto;
      position: relative;

      img {
        width: 100%;
      }
    }
    .task-btn {
      position: absolute;
      width: 289px;
      height: 78px;
      line-height: 82px;
      font-weight: bold;
      bottom: 56px;
      right: 163px;
      font-size: 42px;
      color: #ff3c50;
      background-image: linear-gradient(180deg, #ffe056 0%, #ffbd20 100%);
      background-blend-mode: multiply, normal;
      border-radius: 39px;
    }
    .task-btn-disable {
      color: #f1f1f1;
      background-image: linear-gradient(180deg, #9b9b9b 0%, #878787 100%);
      background-blend-mode: multiply, normal;
    }
  }

  .bottom {
    padding: 20px 0 30px 0;
    display: flex;
    justify-content: center;
    align-items: center;

    .bar {
      width: 100px;
      height: 2PX;
      background: linear-gradient(270deg, rgba(255, 255, 255, .5), rgba(255, 255, 255, 0));
    }

    .desc {
      padding: 0 20px;
      font-size: 33px;
      color: rgba(255, 255, 255, .5);
    }

    .bar.bar-reverse {
      background: linear-gradient(90deg, rgba(255, 255, 255, .5), rgba(255, 255, 255, 0)) !important;
    }
  }

  .van-popup {
    background-color: transparent;
    overflow: visible;
  }

  .modal {
    width: 846px;
    padding: 17px 17px;
    border-radius: 28px;
    position: relative;
    .modal-header {
      position: absolute;
      top: -177px;
      left: 50%;
      transform: translate(-50%, 0);
      img {
        width: 677px;
      }
    }
    .modal-container-1 {
      background-color: #fff8e4;
      border-radius: 28px;
      padding: 16px;
      position: relative;
      z-index: 9;
    }

    .modal-container {
      border: 1PX solid rgba(212, 147, 96, .5);

      border-radius: 28px;
      display: flex;
      flex-direction: column;
      align-items: center;
      padding: 0 0 81px 0;
      box-sizing: border-box;

      .header {
        font-size: 60px;
        color: #a10303;
        font-weight: bold;
        margin-top: 84px;
      }

      .content {
        box-sizing: border-box;
        min-height: 270px;
        padding: 60px 70px 40px 70px;
        color: #c43e3e;
        font-size: 42px;
        line-height: 1.8;
        span {
          color: #ff0000
        }
      }

      .content-prize {
        padding: 94px 0 0 0;

        .prize-img {
          margin-bottom: 58px;

          img {
            width: 630px;
          }
        }

        .prize-content {
          line-height: 2;
          margin-bottom: 95px;
        }
      }

      .rule-content {
        .rule-html {
          font-size: 36px;
          text-align: left;
          padding: 20px 36px 0 36px;
          color: #fb2c17;
          max-height: 1200px;
          overflow-y: auto;

          h1 {
            font-size: 36px;
            font-weight: bold;
            margin: 50px 0 36px 0;

            &:before {
              display: inline-block;
              content: ' ';
              width: 28px;
              height: 28px;
              margin-right: 15px;
              background-image: url(../assets/icon-square.png);
              background-size: 100% 100%;
            }
          }

          p {
            text-align: justify;
            margin: 0;
            padding: 0 0 0 40px
          }

          p.divide {
            height: 78px;
          }
        }

        .rule-desc {
          padding: 67px 0 0 0;
          margin-bottom: -40px;
        }
      }

      .login-content {
        padding: 77px 56px 0 56px;
      }

      .action {
        width: 495px;
        height: 122px;
        color: #a92000;
        font-weight: 600;
        letter-spacing: 2px;
        font-size: 52px;
        line-height: 122px;
        text-align: center;
        background-image: url(../assets/6.png);
        background-size: 100% 100%;
        //background-image: linear-gradient(0deg, #ff2d39 0%, #ff7a81 100%), linear-gradient(#ffbe00, #ffbe00);
      }
    }

    .modal-close {
      width: 96px;
      height: 96px;
      background-image: url(../assets/icon-close.png);
      background-size: 100% 100%;
      position: absolute;
      left: 50%;
      transform: translate(-48px, 0);
      bottom: -160px;
    }
  }

  .poster-show {
    .poster-container {
      width: 800px;
      img {
        width: 100%;
      }
    }
    .modal-close {
      width: 96px;
      height: 96px;
      background-image: url(../assets/icon-close.png);
      background-size: 100% 100%;
      position: absolute;
      left: 50%;
      transform: translate(-48px, 0);
      bottom: -120px;
    }
  }
}
</style>
